import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import connect from 'components/shared/connect'
import { mapResponse } from 'libraries/front-end-core/helpers/dataflow'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { requestGroup } from 'services/CurrentAwarenessService'
import CaAccordionWrapper from 'pages/currentawareness/CaAccordionWrapper'
import { setSignUpModalIsOpen, setUserRolesModalIsOpen } from 'redux/actions'
import selectUrl from 'redux/selectors/selectUrl'
import selectIsLogged from 'redux/selectors/selectIsLogged'
import { map } from 'rxjs/operators'

// news/:aol/archive/id/:id has no anonymous fallback, so replaces the default
// Forbidden/Unauthorized handling (which opens a modal but leaves a blank list).
export const CaArticleAccessDenied = () => {
  const dispatch = useDispatch()
  const currentUrl = useSelector(selectUrl)
  const isLogged = useSelector(selectIsLogged)

  useEffect(() => {
    dispatch(isLogged ? setUserRolesModalIsOpen(true) : setSignUpModalIsOpen(true))
    replaceUrl(currentUrl.replace(/\/id\/[^/]+\/?$/, ''))
  }, [])

  return null
}

const ConnectedCaAccordion = connect(
  ({ fromDate, toDate, searchPhrase, flavour, id, aol }) => {
    return requestGroup({ fromDate, toDate, searchPhrase, flavour, id, aol })
      .pipe(map(mapResponse(group => ({ group }))))
  }
)(CaAccordionWrapper, {
  unauthorizedComponent: CaArticleAccessDenied,
  forbiddenComponent: CaArticleAccessDenied
})

export default ConnectedCaAccordion
